import React, { useEffect, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import {
  Button,
  Card,
  Col,
  Select,
  message,
  Modal,
  Popconfirm,
  Table,
} from "antd";
import $, { data } from "jquery";
//import { Button } from "reactstrap";
import axios from "../services/axios";
import ReactLoading from "react-loading";
import { configConsumerProps } from "antd/lib/config-provider";
import XTable from "./XTable";
import { Collapse } from "antd";
import isConsultant from "../services/isConsultant";
import useAxios from "../hooks/useAxios";
import { checkPermission } from "../utils/checkPermission";
import useRole from "../hooks/useRole";

const CallStatusMapping = (props) => {
  const api = useAxios();
  //REFRESH
  const [refresh, setRefresh] = useState(false);
  const [load, setLoad] = useState(false);
  const [canCreateCallMaster, setCanCreateCallMaster] = useState(false);
  const [canCreateCallStatusMaster, setCanCreateCallStatusMaster] = useState(false);
  const [canCreateCallStatusParametersMaster, setCanCreateCallStatusParametersMaster] = useState(false);
  const [canCreateCallStatusSubParametersMaster, setCanCreateCallStatusSubParametersMaster] = useState(false);
  const [canEditCallStatus, setCanEditCallStatus] = useState(false);
  const [canDeleteCallStatus, setCanDeleteCallStatus] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const createCallMasterAllowed = await checkPermission(
        userRole,
        "call_status_module",
        "create_call_master"
      );
      const createCallStatusMasterAllowed = await checkPermission(
        userRole,
        "call_status_module",
        "create_call_status_master"
      );
      const createCallStatusParametersMasterAllowed = await checkPermission(
        userRole,
        "call_status_module",
        "create_call_status_parameters_master"
      );
      const createCallStatusSubParametersMasterAllowed = await checkPermission(
        userRole,
        "call_status_module",
        "create_call_status_sub_parameters_master"
      );
      const editCallStatusAllowed = await checkPermission(
        userRole,
        "call_status_module",
        "edit_call_status"
      );
      const deleteCallStatusAllowed = await checkPermission(
        userRole,
        "call_status_module",
        "delete_call_status"
      );

      setCanCreateCallMaster(createCallMasterAllowed);
      setCanCreateCallStatusMaster(createCallStatusMasterAllowed);
      setCanCreateCallStatusParametersMaster(createCallStatusParametersMasterAllowed);
      setCanCreateCallStatusSubParametersMaster(createCallStatusSubParametersMasterAllowed);
      setCanEditCallStatus(editCallStatusAllowed);
      setCanDeleteCallStatus(deleteCallStatusAllowed);
    } catch (err) {
      console.error("Error checking call status mapping permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  //MODAL
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [callMasterModalData, setCallMasterModalData] = useState();
  //EDIT HOOKS
  const [editCallMaster, setEditCallMaster] = useState("");
  const [editCallStatusMasterList, setEditCallStatusMasterList] = useState([]);
  const [editInputCallStatusMaster, setEditInputCallStatusMaster] =
    useState("");
  const [editInputCallStatusMasterId, setEditInputCallStatusMasterId] =
    useState("");
  //CALL STATUS PARAMETER MASTER
  const [callStatusParametersList, setCallStatusParametersList] = useState([]);
  const [callStatusSubParametersList, setCallStatusSubParametersList] =
    useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [selectCallStatusParameterId, setSelectCallStatusParameterId] =
    useState("");
  const [editInputCallStatusParameter, setEditInputCallStatusParameter] =
    useState("");
  const [callStatusParamtersMaster, setCallStatusParamtersMaster] =
    useState("");
  const [callStatusSubParamtersMaster, setCallStatusSubParamtersMaster] =
    useState("");
  const [callStatusParametersMaster, setCallStatusParametersMaster] = useState(
    [],
  );
  const [editInputCallStatusSubParameter, setEditInputCallStatusSubParameter] =
    useState("");

  //CALL STATUS MASTER
  const [callStatusMasterData, setCallStatusMasterData] = useState([]);
  const [callStatusParameterMasterData, setCallStatusParameterMasterData] =
    useState([]);
  const [callStatusMasterTableList, setCallStatusMasterTableList] = useState(
    [],
  );
  const [callStatusMaster, setCallStatusMaster] = useState("");
  const [selectCallStatusMaster, setSelectCallStatusMaster] = useState("");
  //CALL MASTER
  const [callMasterData, setCallMasterData] = useState();
  const [callMaster, setCallMaster] = useState("");
  const [selectCallMaster, setSelectCallMaster] = useState("");
  const [selectCallStatusParameterMaster, setSelectCallStatusParameterMaster] =
    useState("");
  const [handleCallMasterTableValue, setHandleCallMasterTableValue] =
    useState("");
  const [selectCallStatusSubParameterId, setSelectCallStatusSubParameterId] =
    useState("");

  //Error validations
  const [ErrorCallMaster, setErrorCallMaster] = useState("");
  const [ErrorCallStatusMaster, setErrorCallStatusMaster] = useState("");
  const [
    ErrorCallStatusSubParameterMaster,
    setErrorCallStatusSubParameterMaster,
  ] = useState("");
  const [ErrorCallStatusParameterMaster, setErrorCallStatusParameterMaster] =
    useState("");

  useEffect(() => {
    getCallMaster();
    getCallStatusMaster();
    //getCallStatusParamteresMaster();
  }, [refresh]);

  const callStatusChangeHandler = (value, record) => {
    axios
      .get("/callStatusParametersMaster/callStatusMasterId/" + value, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        let arr = structuredClone(callStatusMasterTableList);

        arr.forEach((rec) => {
          if (rec.key === record.key) {
            rec.call_status_parameters = res.data.callStatusParameters;
          }
        });

        setCallStatusMasterTableList(arr);
      });
  };

  const callStatusParameterChangeHandler = (value, record) => {
    console.log(record);
    axios
      .get(
        "/callStatusSubParametersMaster/callStatusParametersMasterId/" + value,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        },
      )
      .then((res) => {
        console.log(res.data);
        let arr = structuredClone(callStatusMasterTableList);
        arr.forEach((rec) => {
          if (rec.key === record.key) {
            rec.call_status_sub_parameters = res.data.callStatusSubParameters;
          }
        });

        setCallStatusMasterTableList(arr);
      });
  };

  const handleDeleteCallMaster = (e) => {
    setRefresh(true);
    setLoad(true);
    axios
      .delete("/callMaster/" + e._id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        setLoad(false);
        setRefresh(false);
        success("deleteCallMaster");
      })
      .catch((e) => {
        setLoad(false);
      });
  };

  const columns = [
    {
      title: "Call Master",
      dataIndex: "call_master",
      key: "call_master",
    },
    {
      title: "Call Status",
      dataIndex: "call_status",
      key: "call_status",
      render: (val, record) => {
        return (
          <Select
            placeholder="Select Call Status"
            value={selectedValues[record.key]?.call_status || undefined}
            onChange={(value) => {
              setSelectedValues((prev) => ({
                ...prev,
                [record.key]: {
                  ...prev[record.key],
                  call_status: value,
                },
              }));
              callStatusChangeHandler(value, record);
            }}
            style={{ width: 200 }}
          >
            {record.call_status?.map((ele) => {
              return (
                <Select.Option value={ele?._id}>
                  {ele?.callStatus}
                </Select.Option>
              );
            })}
          </Select>
        );
      },
    },
    {
      title: "Call Status Parameters",
      dataIndex: "call_status_parameters",
      key: "call_status_parameters",
      render: (val, record) => {
        return (
          <Select
            placeholder="Select Call Status Parameters"
            value={
              selectedValues[record.key]?.call_status_parameters || undefined
            }
            onChange={(value) => {
              setSelectedValues((prev) => ({
                ...prev,
                [record.key]: {
                  ...prev[record.key],
                  call_status_parameters: value,
                },
              }));
              callStatusParameterChangeHandler(value, record);
            }}
            style={{ width: 200 }}
          >
            {record.call_status_parameters?.map((ele) => {
              return (
                <Select.Option value={ele?._id}>
                  {ele?.parameterName}
                </Select.Option>
              );
            })}
          </Select>
        );
      },
    },
    {
      title: "Call Status Sub Parameters",
      dataIndex: "call_status_sub_parameters",
      key: "call_status_sub_parameters",
      render: (val, record) => {
        return (
          <Select
            placeholder="Select Call Status Sub Parameters"
            value={
              selectedValues[record.key]?.call_status_sub_parameters ||
              undefined
            }
            style={{ width: 200 }}
            onChange={(value) => {
              setSelectedValues((prev) => ({
                ...prev,
                [record.key]: {
                  ...prev[record.key],
                  call_status_sub_parameters: value,
                },
              }));
            }}
          >
            {record.call_status_sub_parameters?.map((ele) => {
              return (
                <Select.Option value={ele?._id}>
                  {ele?.parameterName}
                </Select.Option>
              );
            })}
          </Select>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 100,
      fixed: "right",
      key: "action",
      render: (val, record) => {
        return (
          <div style={{ display: "flex" }}>
            {canEditCallStatus && (
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                showModal(record.data);
              }}
            >
              <i class="fa fa-edit"></i> Edit
            </button>
            )}
            {canDeleteCallStatus && (
            <Popconfirm
              placement="right"
              title="Are you sure to delete this task?"
              onConfirm={() => {
                handleDeleteCallMaster(record.data);
              }}
              okText="Yes"
              cancelText="No"
            >
              <Button
                style={{
                  display: "block",
                  marginLeft: "1.2rem",
                }}
              >
                X
              </Button>
            </Popconfirm>
            )}
          </div>
        );
      },
    },
  ];

  //alert popup after submission
  const success = (e) => {
    switch (e) {
      case "CallMasterSubmit":
        return message.success("Call Master Submitted, Successfully!", 5);
      case "CallStatusMasterSubmit":
        return message.success("Call Status Master Submitted, Successfully", 5);
      case "submitCallStatusParameter":
        return message.success(
          "Call Status Parameter Submitted, Successfully",
          5,
        );
      case "submitCallStatusSubParameter":
        return message.success(
          "Call Status Sub Parameter Submitted, Successfully",
          5,
        );
      case "deleteCallMaster":
        return message.success("Call Master Deleted, Successfully", 3);
      case "deletCallStatus":
        return message.success("call Status Deleted, Successfully", 3);
      case "CallMasterSaved":
        return message.success("call Master Saved, Successfully", 3);
      case "CallStatusSaved":
        return message.success("call Status  Saved, Successfully", 3);
      case "callStatusParameterSaved":
        return message.success("call Status Prameter  Saved, Successfully", 3);

      default:
        return message.success(
          "Call Status Parameter Deleted, Successfully",
          5,
        );
    }
  };

  const [editCallMasterId, setEditCallMasterId] = useState("");
  //modal will open after clicking on edit button
  const showModal = (e) => {
    console.log("ele.id", e._id);
    setEditCallMasterId(e._id);
    setCallMasterModalData(e);
    setEditCallMaster(e.name);
    setIsModalVisible(true);
    setEditCallStatusMasterList(e.parameterList);
  };

  //Edit Call Master in modal
  const handleInputEditModalCallMaster = (e) => {
    setEditCallMaster(e.target.value);
    setErrorCallMaster("");
  };

  //Edit Call status master on modal
  const onClickEditStatusMaster = (e) => {
    const obj = callMasterModalData.parameterList.filter((ele) => {
      return e.target.value === ele._id;
    });
    setEditInputCallStatusMaster(obj[0]?.callStatus || "");
    setEditInputCallStatusMasterId(obj[0]?._id || "");
    if (e.target.value) {
      axios
        .get(
          "/callStatusParametersMaster/callStatusMasterId/" + e.target.value,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          setCallStatusParametersList(res.data.callStatusParameters);
        });
    }
  };

  const handleInputCallStatusMaster = (e) => {
    setEditInputCallStatusMaster(e.target.value);
  };

  //select to edit call status parameter
  const handleSelectCallStatusParameter = (e) => {
    setSelectCallStatusParameterId(e.target.value);

    const obj = callStatusParametersList?.filter((ele) => {
      return ele._id === e.target.value;
    });
    setEditInputCallStatusParameter(obj[0]?.parameterName || "");
    if (e.target.value) {
      axios
        .get(
          "/callStatusSubParametersMaster/callStatusParametersMasterId/" +
            e.target.value,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          setCallStatusSubParametersList(res.data.callStatusSubParameters);
        });
    }
  };

  const handleSelectCallStatusSubParameter = (e) => {
    const val = e.target.value;
    setSelectCallStatusSubParameterId(val);
    const obj = callStatusSubParametersList?.filter((ele) => {
      return ele._id === e.target.value;
    });
    setEditInputCallStatusSubParameter(obj[0]?.parameterName || "");
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setErrorCallMaster("");
    setErrorCallStatusMaster("");
    setErrorCallStatusParameterMaster("");
  };

  const [activePanel, setActivePanel] = useState("1");

  const { Panel } = Collapse;
  const onChange = (key) => {
    console.log(key);
    setActivePanel(key);
  };

  //get call master data
  const getCallMaster = () => {
    axios
      .get("/callMaster", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        setCallMasterData(res.data.callMaster);
      });
  };

  //BOX 1
  //call master on box 1
  const handleCallMaster = (e) => {
    setCallMaster(e.target.value);
  };

  //submit call master on box 1
  const submitCallMaster = async (e) => {
    e.preventDefault();
    setErrorCallMaster("");
    if (callMaster === "" || callMaster.trim().length === 0) {
      return setErrorCallMaster("Call Master is required");
    } else {
      try {
        setLoad(true);
        setRefresh(true);
        await api.post(
          `/callMaster`,
          { name: callMaster.replace(/\s{2,}/g, " ").trim(), status: true },
          {
            tokenType: "user",
          },
        );
        setCallMaster("");
        setSelectedValues({});
        success("CallMasterSubmit");
        setRefresh(false);
      } catch (err) {
        console.error(err);
        message.error("Something went wrong.");
      } finally {
        setLoad(false);
      }
    }
  };

  //BOX2
  //select call master on box 2 && box 3
  const handleSelectCallMaster = (e) => {
    setSelectCallMaster(e.target.value);
    setErrorCallMaster("");
    if (e.target.value) {
      axios
        .get("/callStatusMaster/callMasterId/" + e.target.value, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        })
        .then((res) => {
          setCallStatusMasterData(res.data.callStatus);
        });
    }
  };
  //input call Status master on box 2
  const handleCallStatusMaster = (e) => {
    setCallStatusMaster(e.target.value);
    setErrorCallStatusMaster("");
  };

  //submit call master on box 2
  const submitCallStatusMaster = (e) => {
    e.preventDefault();
    setRefresh(true);
    if (selectCallMaster === "") {
      setErrorCallMaster("Call Master is required");
    } else if (
      callStatusMaster === "" ||
      callStatusMaster.trim().length === 0
    ) {
      setErrorCallStatusMaster("Call Status Master is required");
    } else {
      setLoad(true);
      axios
        .post(
          "/callStatusMaster",
          {
            callMasterId: selectCallMaster,
            callStatus: callStatusMaster.replace(/\s{2,}/g, " ").trim(),
            status: true,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          // const data = res.data;
          setRefresh(false);
          setLoad(false);
          success("CallStatusMasterSubmit");
          setSelectCallMaster("");
          setCallStatusMaster("");
          setSelectedValues({});
          //window.location.reload();
        })
        .catch((err) => {
          setLoad(false);
          console.error(err);
          message.error("Something went wrong.");
        });
    }
  };

  //BOX3
  //select call status master
  const handleSelectCallStatusMaster = (e) => {
    setSelectCallStatusMaster(e.target.value);
    setErrorCallStatusMaster("");

    if (e.target.value) {
      axios
        .get(
          "callStatusParametersMaster/callStatusMasterId/" + e.target.value,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          setCallStatusParameterMasterData(res.data.callStatusParameters);
        });
    }
  };

  const handleSelectCallStatusParameterMaster = (e) => {
    setSelectCallStatusParameterMaster(e.target.value);
  };

  // select call status parameter master
  const handleCallStatusParamtersMaster = (e) => {
    setCallStatusParamtersMaster(e.target.value);
    setErrorCallStatusParameterMaster("");
  };
  //submit call status parameter master
  const submitCallStatusParamtersMaster = (e) => {
    e.preventDefault();
    setRefresh(true);
    if (selectCallMaster === "") {
      setErrorCallMaster("Call Master is required");
    } else if (selectCallStatusMaster === "") {
      setErrorCallStatusMaster("Call status master is required");
    } else if (
      callStatusParamtersMaster === "" ||
      callStatusParamtersMaster.trim().length === 0
    ) {
      setErrorCallStatusParameterMaster(
        "Call status parameter master is required",
      );
    } else {
      setLoad(true);
      axios
        .post(
          "/callStatusParametersMaster",
          {
            callStatusMasterId: selectCallStatusMaster,
            parameterName: callStatusParamtersMaster
              .replace(/\s{2,}/g, " ")
              .trim(),
            status: true,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          // const data = res.data;
          setRefresh(false);
          setLoad(false);
          success("submitCallStatusParameter");
          setSelectCallMaster("");
          setSelectCallStatusMaster("");
          setSelectedValues({});
          setCallStatusParamtersMaster("");
          // window.location.reload();
        })
        .catch((err) => {
          console.error(err);
          message.error("Something went wrong.");
          setLoad(false);
        });
    }
  };

  const submitCallStatusSubParamtersMaster = (e) => {
    e.preventDefault();
    setRefresh(true);
    if (selectCallMaster === "") {
      setErrorCallMaster("Call Master is required");
    } else if (selectCallStatusMaster === "") {
      setErrorCallStatusMaster("Call status master is required");
    } else if (selectCallStatusParameterMaster === "") {
      setErrorCallStatusParameterMaster(
        "Call status parameter master is required",
      );
    } else if (
      callStatusSubParamtersMaster === "" ||
      callStatusSubParamtersMaster.trim().length === 0
    ) {
      setErrorCallStatusSubParameterMaster(
        "Call status sub parameter master is required",
      );
    } else {
      setLoad(true);
      axios
        .post(
          "/callStatusSubParametersMaster",
          {
            callStatusParametersMasterId: selectCallStatusParameterMaster,
            parameterName: callStatusSubParamtersMaster
              .replace(/\s{2,}/g, " ")
              .trim(),
            status: true,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          // const data = res.data;
          setRefresh(false);
          setLoad(false);
          success("submitCallStatusSubParameter");
          setSelectCallMaster("");
          setSelectCallStatusMaster("");
          setSelectedValues({});
          setCallStatusParamtersMaster("");
          setSelectCallStatusParameterMaster("");
          setCallStatusSubParamtersMaster("");
          // window.location.reload();
        })
        .catch((err) => {
          setLoad(false);
          console.error(err);
          message.error("Something went wrong.");
        });
    }
  };

  //TABLE DATA
  //get call status master data
  const getCallStatusMaster = () => {
    axios
      .get("/callStatusMaster", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        let rows = [];

        for (let i = 0; i < res.data.length; i++) {
          rows.push({
            key: i + 1,
            call_master: res.data[i].name,
            call_status: res.data[i].parameterList,
            call_status_parameters: [],
            call_status_sub_parameters: [],
            data: res.data[i],
          });
        }
        setCallStatusMasterTableList(rows);
      });
  };

  const handleTableCallStatus = (e) => {
    setHandleCallMasterTableValue(e.target.value);
    if (e.target.value) {
      axios
        .get(
          "/callStatusParametersMaster/callStatusMasterId/" + e.target.value,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          setCallStatusParametersMaster(res.data.callStatusParameters);
        });
    }
  };

  //DELETE ON MODAL
  const handleDeleteCallStatusMaster = (e) => {
    if (
      editInputCallStatusMasterId === "" ||
      editInputCallStatusMaster === "" ||
      editInputCallStatusMaster.trim().length === 0
    ) {
      setErrorCallStatusMaster("Call status master is required");
    } else {
      axios
        .delete("/callStatusMaster/" + editInputCallStatusMasterId, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        })
        .then((res) => {
          const data = res.data;
          success("deletCallStatus");
          window.location.reload();
        });
    }
  };

  const handleDeleteCallStatusParameter = (e) => {
    if (
      selectCallStatusParameterId === "" ||
      editInputCallStatusParameter === "" ||
      editInputCallStatusParameter.trim().length === 0
    ) {
      setErrorCallStatusParameterMaster("Call status parameter is required");
    } else {
      axios
        .delete("/callStatusParametersMaster/" + selectCallStatusParameterId, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        })
        .then((res) => {
          const data = res.data;
          window.location.reload();
        });
    }
  };

  const handleDeleteCallStatusSubParameter = (e) => {
    if (
      selectCallStatusSubParameterId === "" ||
      editInputCallStatusSubParameter === "" ||
      editInputCallStatusSubParameter.trim().length === 0
    ) {
      setErrorCallStatusSubParameterMaster(
        "Call status sub parameter is required",
      );
    } else {
      axios
        .delete(
          "/callStatusSubParametersMaster/" + selectCallStatusSubParameterId,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          const data = res.data;
          window.location.reload();
        });
    }
  };

  const saveEdittedCallMaster = (e) => {
    if (editCallMaster === "" || editCallMaster.trim().length === 0) {
      setErrorCallMaster("Call master is required");
    } else {
      setLoad(true);
      axios
        .put(
          "/callMaster/" + editCallMasterId,
          {
            name: editCallMaster.replace(/\s{2,}/g, " ").trim(),
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          const data = res.data;
          setLoad(false);
          success("CallMasterSaved");
          window.location.reload();
        })
        .catch((err) => {
          setLoad(false);
        });
    }
  };

  const saveEdittedCallStatus = (e) => {
    if (
      editInputCallStatusMaster === "" ||
      editInputCallStatusMaster.trim().length === 0
    ) {
      setErrorCallStatusMaster("Call status master is required");
    } else {
      setErrorCallStatusMaster("");
      setLoad(true);
      axios
        .put(
          "/callStatusMaster/" + editInputCallStatusMasterId,
          {
            callMasterId: editCallMasterId,
            callStatus: editInputCallStatusMaster
              .replace(/\s{2,}/g, " ")
              .trim(),
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          const data = res.data;
          setLoad(false);
          success("CallStatusSaved");
          window.location.reload();
        })
        .catch((e) => {
          setLoad(false);
        });
    }
  };

  const saveEdittedCallStatusParameter = (e) => {
    if (
      editInputCallStatusParameter === "" ||
      editInputCallStatusParameter.trim().length === 0
    ) {
      setErrorCallStatusParameterMaster("Call status parameter is required");
    } else {
      setErrorCallStatusParameterMaster("");
      setLoad(true);
      axios
        .put(
          "/callStatusParametersMaster/" + selectCallStatusParameterId,
          {
            callStatusMasterId: editInputCallStatusMasterId,
            parameterName: editInputCallStatusParameter
              .replace(/\s{2,}/g, " ")
              .trim(),
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          const data = res.data;
          window.location.reload();
          setLoad(false);
          success("CallStatusParameterSaved");
        })
        .catch((e) => {
          setLoad(false);
        });
    }
  };

  const saveEdittedCallStatusSubParameter = (e) => {
    // return
    if (
      editInputCallStatusSubParameter === "" ||
      editInputCallStatusSubParameter.trim().length === 0
    ) {
      setErrorCallStatusSubParameterMaster(
        "Call status sub parameter is required",
      );
    } else {
      setErrorCallStatusSubParameterMaster("");
      setLoad(true);
      axios
        .put(
          "/callStatusSubParametersMaster/" + selectCallStatusSubParameterId,
          {
            callStatusParametersMasterId: selectCallStatusParameterId,
            parameterName: editInputCallStatusSubParameter
              .replace(/\s{2,}/g, " ")
              .trim(),
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          const data = res.data;
          window.location.reload();
          setLoad(false);
          success("CallStatusParameterSaved");
        })
        .catch((e) => {
          setLoad(false);
        });
    }
  };

  return (
    <div>
      {!isConsultant() && (
        <Dashboard title="Call Status Mapping">
          {load && (
            <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
          )}
          <div className="row mb-4">
            <div className="col-lg-4">
              <Card className="border">
                <Collapse
                  onChange={onChange}
                  activeKey={activePanel}
                  className="bg-white border-0"
                >
                  <Panel header="Call Master" key="1">
                    <div className="form-group mb-0">
                      <input
                        placeholder="Enter Status"
                        value={callMaster}
                        type="text"
                        onChange={handleCallMaster}
                        class="form-control"
                        id="usr"
                      />
                      {ErrorCallMaster && (
                        <div
                          className="text-danger"
                          style={{ marginTop: 5 + "px" }}
                        >
                          {ErrorCallMaster}
                        </div>
                      )}
                      {canCreateCallMaster && (
                      <button
                        onClick={submitCallMaster}
                        style={{
                          marginTop: "15px",
                        }}
                        className="btn btn-primary"
                      >
                        Create
                      </button>
                      )}
                    </div>
                  </Panel>
                  <Panel header="Call Status Master" key="2">
                    <div className="form-group mb-0">
                      <select
                        id="FormType"
                        className="mb-2 form-control "
                        onChange={handleSelectCallMaster}
                        value={selectCallMaster}
                      >
                        <option value="" selected="true">
                          Select Status
                        </option>
                        {callMasterData?.map((ele, i) => {
                          return (
                            <option key={i} value={ele._id}>
                              {ele.name}
                            </option>
                          );
                        })}
                      </select>
                      {ErrorCallMaster && (
                        <div
                          className="text-danger"
                          style={{ marginTop: 5 + "px" }}
                        >
                          {ErrorCallMaster}
                        </div>
                      )}
                      <input
                        style={{
                          marginTop: "15px",
                        }}
                        placeholder="Enter Reason"
                        type="text"
                        class="form-control"
                        id="usr"
                        onChange={handleCallStatusMaster}
                        value={callStatusMaster}
                      />
                      {ErrorCallStatusMaster && (
                        <div
                          className="text-danger"
                          style={{ marginTop: 5 + "px" }}
                        >
                          {ErrorCallStatusMaster}
                        </div>
                      )}
                      {canCreateCallStatusMaster && (
                      <button
                        onClick={submitCallStatusMaster}
                        style={{
                          marginTop: "15px",
                        }}
                        className="btn btn-primary"
                      >
                        Create
                      </button>
                      )}
                    </div>
                  </Panel>
                  <Panel header="Call Status Paramerters Master" key="3">
                    <div className="form-group mb-0">
                      <select
                        id="FormType"
                        className="mb-2 form-control "
                        onChange={handleSelectCallMaster}
                        value={selectCallMaster}
                      >
                        <option value="" selected="true">
                          Select Status
                        </option>
                        {callMasterData?.map((ele, i) => {
                          return (
                            <option key={i} value={ele._id}>
                              {ele.name}
                            </option>
                          );
                        })}
                      </select>
                      {ErrorCallMaster && (
                        <div
                          className="text-danger"
                          style={{ marginTop: 5 + "px" }}
                        >
                          {ErrorCallMaster}
                        </div>
                      )}
                      <select
                        id="FormType"
                        className="mb-2 form-control "
                        onChange={handleSelectCallStatusMaster}
                        value={selectCallStatusMaster}
                      >
                        <option value="" selected="true">
                          Select Status
                        </option>
                        {callStatusMasterData?.map((ele, i) => {
                          return (
                            <option key={i} value={ele._id}>
                              {ele.callStatus}
                            </option>
                          );
                        })}
                      </select>
                      {ErrorCallStatusMaster && (
                        <div
                          className="text-danger"
                          style={{ marginTop: 5 + "px" }}
                        >
                          {ErrorCallStatusMaster}
                        </div>
                      )}

                      <input
                        style={{
                          marginTop: "15px",
                        }}
                        placeholder="Enter Reason"
                        type="text"
                        class="form-control"
                        id="usr"
                        onChange={handleCallStatusParamtersMaster}
                        value={callStatusParamtersMaster}
                      />
                      {ErrorCallStatusParameterMaster && (
                        <div
                          className="text-danger"
                          style={{ marginTop: 5 + "px" }}
                        >
                          {ErrorCallStatusParameterMaster}
                        </div>
                      )}

                      {canCreateCallStatusParametersMaster && (
                      <button
                        onClick={submitCallStatusParamtersMaster}
                        style={{
                          marginTop: "15px",
                        }}
                        className="btn btn-primary"
                      >
                        Create
                      </button>
                      )}
                    </div>
                  </Panel>
                  <Panel header="Call Status Sub Paramerters Master" key="4">
                    <div className="form-group mb-0">
                      <select
                        id="FormType"
                        className="mb-2 form-control "
                        onChange={handleSelectCallMaster}
                        value={selectCallMaster}
                      >
                        <option value="" selected="true">
                          Select Status
                        </option>
                        {callMasterData?.map((ele, i) => {
                          return (
                            <option key={i} value={ele._id}>
                              {ele.name}
                            </option>
                          );
                        })}
                      </select>
                      {ErrorCallMaster && (
                        <div
                          className="text-danger"
                          style={{ marginTop: 5 + "px" }}
                        >
                          {ErrorCallMaster}
                        </div>
                      )}
                      <select
                        id="FormType"
                        className="mb-2 form-control "
                        onChange={handleSelectCallStatusMaster}
                        value={selectCallStatusMaster}
                      >
                        <option value="" selected="true">
                          Select Status
                        </option>
                        {callStatusMasterData?.map((ele, i) => {
                          return (
                            <option key={i} value={ele._id}>
                              {ele.callStatus}
                            </option>
                          );
                        })}
                      </select>
                      {ErrorCallStatusMaster && (
                        <div
                          className="text-danger"
                          style={{ marginTop: 5 + "px" }}
                        >
                          {ErrorCallStatusMaster}
                        </div>
                      )}

                      <select
                        id="FormType"
                        className="mb-2 form-control "
                        onChange={handleSelectCallStatusParameterMaster}
                        value={selectCallStatusParameterMaster}
                      >
                        <option value="" selected="true">
                          Select Status
                        </option>
                        {callStatusParameterMasterData?.map((ele, i) => {
                          return (
                            <option key={i} value={ele._id}>
                              {ele.parameterName}
                            </option>
                          );
                        })}
                      </select>
                      {ErrorCallStatusMaster && (
                        <div
                          className="text-danger"
                          style={{ marginTop: 5 + "px" }}
                        >
                          {ErrorCallStatusMaster}
                        </div>
                      )}

                      <input
                        style={{
                          marginTop: "15px",
                        }}
                        placeholder="Enter Reason"
                        type="text"
                        class="form-control"
                        id="usr"
                        onChange={(e) =>
                          setCallStatusSubParamtersMaster(e.target.value)
                        }
                        value={callStatusSubParamtersMaster}
                      />
                      {ErrorCallStatusSubParameterMaster && (
                        <div
                          className="text-danger"
                          style={{ marginTop: 5 + "px" }}
                        >
                          {ErrorCallStatusSubParameterMaster}
                        </div>
                      )}

                      {canCreateCallStatusSubParametersMaster && (
                      <button
                        onClick={submitCallStatusSubParamtersMaster}
                        style={{
                          marginTop: "15px",
                        }}
                        className="btn btn-primary"
                      >
                        Create
                      </button>
                      )}
                    </div>
                  </Panel>
                </Collapse>
              </Card>
            </div>

            {/* TABLE FOR DISPLAYING STATUS DATA */}
            <div className="col-lg-8">
              <Card className="border">
                <Table
                  dataSource={callStatusMasterTableList}
                  columns={columns}
                  scroll={{ x: true }}
                  style={{ whiteSpace: "pre" }}
                  pagination={false}
                  size="small"
                />
              </Card>
            </div>
            <Modal
              title="Edit"
              width={600}
              visible={isModalVisible}
              footer={[
                <>
                  <button className="btn btn-secondary" onClick={handleCancel}>
                    Cancel
                  </button>
                </>,
              ]}
              onOk={handleOk}
              onCancel={handleCancel}
            >
              <div className="form-group mb-0">
                <label>Call Master</label>
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <div className="d-flex flex-column w-100">
                    <input
                      placeholder="Enter Status"
                      value={editCallMaster}
                      type="text"
                      onChange={handleInputEditModalCallMaster}
                      class="form-control"
                      id="usr"
                    />
                    {ErrorCallMaster && (
                      <div
                        className="text-danger"
                        style={{ marginTop: 5 + "px" }}
                      >
                        {ErrorCallMaster}
                      </div>
                    )}
                  </div>
                  {/* {inputEditStatusError && (
              <div className="text-danger" style={{ marginTop: 5 + "px" }}>
                {inputEditStatusError}
              </div>
            )} */}

                  <button
                    className="btn btn-sm btn-primary"
                    onClick={saveEdittedCallMaster}
                  >
                    Save
                  </button>
                </div>
              </div>

              <div className="form-group mb-0">
                <label className="my-2">Call Status Master</label>
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <div className="d-flex flex-column w-100">
                    <select
                      id="FormType"
                      className="mb-2 form-control "
                      onChange={onClickEditStatusMaster}
                      //value={editReason}
                    >
                      <option value="" selected>
                        Select reason
                      </option>
                      {editCallStatusMasterList?.map((ele) => {
                        return (
                          <option value={ele?._id}>{ele?.callStatus}</option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <div className="d-flex flex-column w-100">
                    <input
                      placeholder="Enter Status"
                      value={editInputCallStatusMaster}
                      type="text"
                      onChange={handleInputCallStatusMaster}
                      class="form-control"
                      id="usr"
                    />
                    {ErrorCallStatusMaster && (
                      <div
                        className="text-danger"
                        style={{ marginTop: 5 + "px" }}
                      >
                        {ErrorCallStatusMaster}
                      </div>
                    )}
                  </div>
                  {/* {inputEditReasonError && (
                <div className="text-danger" style={{ marginTop: 5 + "px" }}>
                  {inputEditReasonError}
                </div>
              )} */}

                  <button
                    className="btn btn-sm btn-primary"
                    onClick={saveEdittedCallStatus}
                  >
                    Save
                  </button>

                  <Popconfirm
                    title="Are you sure to delete this task?"
                    onConfirm={handleDeleteCallStatusMaster}
                    //  onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                  >
                    <button
                      className="btn btn-danger btn-sm"
                      // onClick={handleDeleteStatus}
                    >
                      X
                    </button>
                  </Popconfirm>
                </div>
              </div>

              <div className="form-group mb-0">
                <label className="my-2">Call Status Paramerters Master</label>
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <div className="d-flex flex-column w-100">
                    <select
                      id="FormType"
                      className="mb-2 form-control "
                      onChange={handleSelectCallStatusParameter}
                      value={selectCallStatusParameterId}
                    >
                      <option value="" selected="true">
                        Select Status
                      </option>
                      {callStatusParametersList?.map((ele, i) => {
                        return (
                          <option key={i} value={ele?._id}>
                            {ele?.parameterName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <div className="d-flex flex-column w-100">
                    <input
                      placeholder="Enter Status"
                      value={editInputCallStatusParameter}
                      type="text"
                      onChange={(e) =>
                        setEditInputCallStatusParameter(e.target.value)
                      }
                      class="form-control"
                      id="usr"
                    />
                    {ErrorCallStatusParameterMaster && (
                      <div
                        className="text-danger"
                        style={{ marginTop: 5 + "px" }}
                      >
                        {ErrorCallStatusParameterMaster}
                      </div>
                    )}
                  </div>
                  {/* {inputEditReasonError && (
                <div className="text-danger" style={{ marginTop: 5 + "px" }}>
                  {inputEditReasonError}
                </div>
              )} */}

                  <button
                    className="btn btn-sm btn-primary"
                    onClick={saveEdittedCallStatusParameter}
                  >
                    Save
                  </button>

                  <Popconfirm
                    title="Are you sure to delete this task?"
                    onConfirm={handleDeleteCallStatusParameter}
                    //  onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                  >
                    <button
                      className="btn btn-danger btn-sm"
                      // onClick={handleDeleteStatus}
                    >
                      X
                    </button>
                  </Popconfirm>
                </div>
              </div>
              <div className="form-group mb-0">
                <label className="my-2">
                  Call Status Sub Paramerters Master
                </label>
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <div className="d-flex flex-column w-100">
                    <select
                      id="FormType"
                      className="mb-2 form-control "
                      onChange={handleSelectCallStatusSubParameter}
                      value={selectCallStatusSubParameterId}
                    >
                      <option value="" selected="true">
                        Select Status
                      </option>
                      {callStatusSubParametersList?.map((ele, i) => {
                        return (
                          <option key={i} value={ele?._id}>
                            {ele?.parameterName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <div className="d-flex flex-column w-100">
                    <input
                      placeholder="Enter Status"
                      value={editInputCallStatusSubParameter}
                      type="text"
                      onChange={(e) =>
                        setEditInputCallStatusSubParameter(e.target.value)
                      }
                      class="form-control"
                      id="usr"
                    />
                    {ErrorCallStatusSubParameterMaster && (
                      <div
                        className="text-danger"
                        style={{ marginTop: 5 + "px" }}
                      >
                        {ErrorCallStatusSubParameterMaster}
                      </div>
                    )}
                  </div>
                  {/* {inputEditReasonError && (
                <div className="text-danger" style={{ marginTop: 5 + "px" }}>
                  {inputEditReasonError}
                </div>
              )} */}

                  <button
                    className="btn btn-sm btn-primary"
                    onClick={saveEdittedCallStatusSubParameter}
                  >
                    Save
                  </button>

                  <Popconfirm
                    title="Are you sure to delete this task?"
                    onConfirm={handleDeleteCallStatusSubParameter}
                    //  onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                  >
                    <button
                      className="btn btn-danger btn-sm"
                      // onClick={handleDeleteStatus}
                    >
                      X
                    </button>
                  </Popconfirm>
                </div>
              </div>
              {/* <button className="btn btn-primary mt-3" onClick={handleOk}>
                Save
              </button> */}
            </Modal>
          </div>
        </Dashboard>
      )}
    </div>
  );
};

export default CallStatusMapping;
